import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link ,useNavigate} from 'react-router-dom';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import '../style.css';

function formatNumber(number, length) {
    return String(number).padStart(length, '0');
}

function App() {

    const location = useLocation();
    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };
    
    const dealerId = getQueryParam('id');

    const [getData, setGetData] = useState('');
	const [total, setTotal] = useState(0);
	const [paid, setPaid] = useState(0);
	const [discount, setDiscount] = useState(0);
	const [gst, setGST] = useState(0);
	const [error, setError] = useState('');

    const getdata = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/dealers/reports/',{dealerId: dealerId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
		
            console.log(response.data);

			if(response.data.status === 'success'){
				setGetData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

    const calc = () => {
        let total = 0;
        let paid = 0;
        let gst = 0;
        let discount = 0;

        getData?.orderData?.forEach(order => {

            if(order.paymentStatus === 'paid'){
                paid += parseFloat(order.totalPayment);
            }
            total += parseFloat(order.totalPayment);
            gst += parseFloat(order.gst);
            discount += parseFloat(order.discount);
        });

        setTotal(total);
        setDiscount(discount);
        setPaid(paid);
        setGST(gst);
    };

    useEffect(() => {
        calc();
    },[getData]);

	useEffect(() => {
		getdata();
	},[]);


return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
			<div class="box">
				<div class="box-header with-border">
				  <h4 class="box-title">Distributers Data</h4>
				  <p class="mb-0 box-subtitle">Dealers Report</p>
				</div>
				<div class="box-body">
                    <div class="row mb-4">
						<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-6 col-12">
                            <div class="space-between">
						
								<div>
                            		<h6 style={{fontWeight: '600'}}>{getData?.dealer}</h6>
                                	<p>{getData?.name}</p>
                                	<p>{getData?.location}, {getData?.route}</p>
                                	<p>{getData?.phone}<br />{getData?.email}</p>
                                	<p>{getData?.address}</p>
								</div>

                                <div>
                                    <div class="row">
                                        
                                        <a class="btn btn-primary mt-4" href={`/dealer-incentive?id=${dealerId}`}>Incentive</a>
                                        <a class="btn btn-warning mt-4" href={`/ledger?id=${dealerId}`}>Ledger</a>
                                    </div>
                                    
                                </div>
								
                            </div>
                        </div>
                    </div>

					<div class="table-responsive">
					  <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
						<thead>
							<tr class="text-dark">
								<th>S.No</th>
								<th>Date</th>
								<th>Invoice</th>
								<th>Total</th>
								<th>GST</th>
								<th>Discount</th>
								<th>Payment</th>
								<th>Options</th>
							</tr>
						</thead>
						<tbody>
							{getData?.orderData?.length > 0 ? getData?.orderData?.map((data, index) =>
							<tr key={index}>
								<td class="text-dark">{index+1}</td>
								<td class="text-dark">{data.date}</td>
								<td>#{formatNumber(data.id, 6)}</td>
								<td>{parseFloat(data.totalPayment).toFixed(2)}</td>
								<td>{parseFloat(data.gst).toFixed(2)}</td>
								<td>{parseFloat(data.discount).toFixed(2)}</td>
								<td>{data.paymentStatus === 'paid' ? <p class="text-success">Paid</p> : <p class="text-danger">Not Paid</p>}</td>
                                <td>
                                    <a href={`invoice-details?id=${data.orderId}`} class="btn btn-sm btn-secondary">View</a>
                                </td>
								
								
							</tr>
							):(
								<tr>
									<td colSpan={6}>No Data</td>
								</tr>
							)}
							
						</tbody>	
					</table>
					</div>              
				</div>
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;